import {UserRoleDetailComponent} from "./user-role-detail.component";

export default UserRoleDetailComponent;
